import gql from 'graphql-tag';

export const CLOSED_LOST_REPORT = gql`
  query ClosedLostReport($input: ClosedLostReportInput!) {
    closedLostReport(input: $input) {
      rows {
        name
        dealsLost
        dealValueLost
        grossLost
        avgDaysInPipeline
        lossReasons {
          reasonLabel
          dealsLost
          percentOfLost
        }
      }
      totalLostDeals
      totalValueLost
      grossProfitLost
      avgDaysToLost
      avgGrossProfitLost
      avgTotalValueLost
      reasonTotals {
        reasonLabel
        total
      }
      outcomeSummary {
        totalClosed
        closedWon
        closedLost
        percentWon
        percentLost
        valueWon
        valueLost
        wonMissingClosedOn
      }
    }
  }
`;
